function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

function autoPlayOnView(className, threshold = 0.5) {
    // threshold 当视频有 50% 的面积进入浏览器可视区域时 执行 play()
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
          observer.unobserve(entry.target); // 播放一次后取消观察
        }
      });
    }, { threshold });
  
    elements.forEach(el => observer.observe(el));
}

var wFlag=window.innerWidth>750

onViewLoad('.lazy_video')
if(wFlag){
    onViewLoad('.lazy_video_p')
}else{
    onViewLoad('.lazy_video_m')
}

$(()=>{
    setTimeout(() => {
        $('.box1_title').css({transform:'translateY(0)',opacity:1})
    }, 200);

    ScrollTrigger.create({
        trigger:'.box1_1',
        start:'top top+=4%',
        end:'+=80%',
        pin:true,
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 100);
            for(let i=0;i<4;i++){
                if(index>i*25){
                    $('.box1_1 div').eq(i).addClass('box1_active').siblings().removeClass('box1_active')
                }
            }
        }
    })

    //box2
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box2_item',
            start:'top bottom-=40%',
            end:'+=0%',
            //toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box2_item div',{opacity:0,y:'2rem',stagger:0.2})
        })

        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=4%',
            end:'+=40%',
            pin:true
        })
    }

    //box3
    var box3Swiper = new Swiper('.box3Swiper', {
        autoplay: true,
        effect: 'fade',
        loop:true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box3_icon div').eq(index).addClass('box3Active').siblings().removeClass('box3Active')
            }
        }
    })
    $('.box3_icon div').click(function(){
        var index = $(this).index()
        box3Swiper.slideTo(index+1,300);
    })

    //box4
    showUp('.box4_text')
    if(wFlag){
        var $video = $('.box4_video');

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=130% top',
            end:'+=30%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box4_mask',{opacity:0})
                .from('.box4_mask div',{opacity:0,scale:4})
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=50% top',
            end:'+=150%',
            scrub:true,
            onUpdate: function (self) {
                //console.log($video[0].duration) 0.52 0.62
                $video[0].currentTime = self.progress * 7.1;
                //console.log(self.progress)
                $('.b4Text3').toggleClass('opacity0',self.progress>0.18)
                $('.b4Text4').toggleClass('opacity1',self.progress>0.3)
                $('.box4_flag').toggleClass('opacity0',self.progress>0.55)
                $('.b4Text5').toggleClass('opacity1',self.progress>0.62)
            }
        })
    
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=50% top',
            end:'+=220%',
            pin:true,
        })
    }else{
        const videoEl = $('.box4_video')[0]
        let vFlag = false

        if (videoEl) {
            // 视频进度监听，只绑定一次
            $(videoEl).on('timeupdate', function () {
                if (!videoEl.duration) return
                const progress = videoEl.currentTime / videoEl.duration
                if (progress > 0.18) {
                    $('.b4Text3').addClass('opacity0')
                }
                if (progress > 0.25) {
                    $('.b4Text4').addClass('opacity1')
                }
                if (progress > 0.55) {
                    $('.box4_flag').addClass('opacity0')
                }
                if (progress > 0.6) {
                    $('.b4Text5').addClass('opacity1')
                }
            })

            // 视频完整播放结束后，才解除锁定
            $(videoEl).on('ended', function () {
                vFlag = false
            })

            // 重置文字动画
            function resetVideoText() {
                $('.b4Text3').removeClass('opacity0')
                $('.b4Text4').removeClass('opacity1')
                $('.box4_flag').removeClass('opacity0')
                $('.b4Text5').removeClass('opacity1')
            }

            // 播放视频
            function playVideo() {
                // 上一轮还没播放完，禁止再次触发
                if (vFlag) return
                // 立即锁定
                vFlag = true
                // 重置上一轮动画
                resetVideoText()
                // 视频回到开头
                videoEl.currentTime = 0
                // 开始播放
                videoEl.play().catch(function (err) {
                    console.warn('视频播放失败：', err)
                    // 如果播放失败，需要解除锁定
                    vFlag = false
                })
            }

            ScrollTrigger.create({
                trigger: '.box4',
                start: 'top+=35% top',
                end: '+=0%',
                onEnter: function () {
                    playVideo()
                },
                onLeaveBack: function () {
                    playVideo()
                }
            })
        }
    }
    
    //box5
    showUp('.box5_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top',
            end:'+=60%',
            pin:true,
            onUpdate: function (self) {
                let index = Math.floor(self.progress * 100);
                if(index>2){
                    $('.box5_items').css({transform:'translate(18%)'})
                }
                if(index>30){
                    $('.box5_items').css({transform:'translate(-16%)'})
                }
                if(index>70){
                    $('.box5_items').css({transform:'translate(-50%)'})
                }
            }
        })
    }
    
    //box6
    showUp('.box6_title')
    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top top+=20%':'top center',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box6_mah',{opacity:0,y:'2rem'})
    })
    
    //box7
    if(wFlag){
        showUp('.b7Flag1')
    }else{
        showUp('.b7Flag2')
    }
    
    //box8
    ScrollTrigger.create({
        trigger:'.box8',
        start:wFlag?'top+=2% top':'top top+=20%',
        end:'+=40%',
        pin:wFlag,
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 100);
            $('.box8_title').toggleClass('opacity0',index>30)
            $('.box8_mask').toggleClass('box8Active',index>30)
        }
    })
    
    //box9
    if(wFlag){
        var $video1 = $('.box9_video');
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top top+=4%',
            end:'+=80%',
            scrub:true,
            onUpdate: function (self) {
                //console.log($video1[0].duration)
                $video1[0].currentTime = self.progress * 2.04;
                $('.box9 div').toggleClass('opacity1',self.progress>0.95)
            }
        })
    
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top top+=4%',
            end:'+=100%',
            pin:true,
        })
    }else{
        showUp('.box9 div')
    }

    //box10
    showUp('.box10_title')
    new Swiper('.box10Swiper', {
        slidesPerView:wFlag? 9: 4,
        centeredSlides: true,
        autoplay:true,
        navigation: {
            nextEl: '.box10Swiper-button-next',
            prevEl: '.box10Swiper-button-prev',
        },
    })
    $('.box10_nav div').click(function(){
        var index = $(this).index()
        $('.box10_content .box10_items').hide()
        $(`.box10_content .box10_items:nth-child(${index+1})`).show()
        $('.box10_nav div').css({color:'#50220C'})
        $(this).css({color:'white'})
        if(index==0){
            $('.box10_nav span').css({left:'1%'})
            $('.box10_title span:nth-child(2)').css({display:'block'})
            $('.box10_title span:nth-child(3)').hide()
        }else{
            $('.box10_nav span').css({left:'51%'})
            $('.box10_title span:nth-child(3)').css({display:'block'})
            $('.box10_title span:nth-child(2)').hide()
        }
    })
    
    //box11
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box11',
            start:'top top+=6%',
            end:'+=30%',
            pin:true,
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box11_text',{y:'18rem',scale:2.5})
                .from('.box11_mask',{opacity:0})
        })

        ScrollTrigger.create({
            trigger:'.box11_scroll',
            start:wFlag?'top center':'top bottom-=30%',
            end:'+=60%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box11_scroll div',{x:wFlag?'-38%':'-72%'})
        })
    }else{
        showUp('.box11_text')
        showUp('.box11_title')
        showUp('.box11_scroll div')
    }

    //box12
    $('.box12_nav div').click(function(){
        var index = $(this).index()
        $('.box12_nav div').css({color:'#50220C'})
        $(this).css({color:'white'})
        if(index==0){
            $('.box12_nav span').css({left:'1%'})
            $('.box12_img1').css({transform:'translate(36%)'})
            $('.box12_left div:last-child').css({opacity:0})
        }else{
            $('.box12_nav span').css({left:'51%'})
            $('.box12_img1').css({transform:'translate(0%)'})
            $('.box12_left div:last-child').css({opacity:1})
        }
    })

    //box13
    showUp('.box13_title')
    if(wFlag){
        $('.box13_item').hover(function(){
            $('.box13_item video').each(function() {
                this.pause();
            });
            $(this).find('video')[0].play();
        })
    }else{
        new Swiper('.box13Swiper', {
            slidesPerView: 1.5,
            centeredSlides: true,
            autoplay:true,
            on:{
                slideChangeTransitionEnd: function(){
                    $('.box13_item video').css({filter:'brightness(0.4)'})
                    $('.box13_item video').each(function() {
                        this.pause();
                    });
                    $('.box13Swiper .swiper-slide-active .box13_item video').css({filter:'none'})
                    $('.box13Swiper .swiper-slide-active .box13_item video')[0].play()
                },
            },
        })
    }

    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })
    

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
       //window.open('https://store.oxva.com/products/oxva-xlim-go-lite'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})